// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JbR3U","index":"styles_index__yYkxS"};